import React, { useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";

export default function WorkWithUsFormInline({ onClose }) {
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size <= 5 * 1024 * 1024) {
      setFile(selectedFile);
    } else {
      alert("❌ File must be smaller than 5MB!");
      e.target.value = "";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ Form submitted successfully!");
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1.5rem",
        zIndex: 2147483646,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          width: "100%",
          maxWidth: 520,
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          padding: "24px",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 10,
            right: 12,
            border: "none",
            background: "transparent",
            fontSize: 20,
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        <h3 style={{ marginBottom: 16 }}>Work With Us</h3>

        <form onSubmit={handleSubmit}>
          {/* Name + Email */}
          <div style={{ display: "flex", gap: "12px", marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Full Name</label>
              <input
                type="text"
                name="name"
                required
                placeholder="Enter your name"
                style={inputStyle}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Email</label>
              <input
                type="email"
                name="email"
                required
                placeholder="Enter your email"
                style={inputStyle}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Phone + Role */}
          <div style={{ display: "flex", gap: "12px", marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Phone Number</label>
              <input
                type="tel"
                name="phone"
                required
                placeholder="Enter your phone number"
                style={inputStyle}
                onChange={handleChange}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Select Role</label>
              <select
                name="role"
                required
                style={inputStyle}
                onChange={handleChange}
              >
                <option value="">Select a role</option>
                <option value="fullstack">Full Stack Developer</option>
                <option value="backend">Backend Engineering</option>
                <option value="devops">DevOps Engineering</option>
              </select>
            </div>
          </div>

          {/* File Upload */}
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Upload Resume</label>
            <label
              htmlFor="resumeUpload"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #683FEA",
                borderRadius: 10,
                padding: "20px",
                cursor: "pointer",
                textAlign: "center",
                transition: "all 0.3s ease",
              }}
            >
              <FaCloudUploadAlt size={40} color="#683FEA" />
              <p style={{ margin: "6px 0", fontWeight: 500 }}>
                <strong>Drag & drop your file</strong> or click to upload
              </p>
              <small style={{ color: "#666" }}>
                Supports PDF, JPEG (Max 5MB)
              </small>
              <input
                type="file"
                id="resumeUpload"
                accept=".pdf,.jpeg,.jpg"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </label>
            {file && (
              <div style={{ marginTop: 8, color: "green", fontSize: 14 }}>
                ✅ {file.name}
              </div>
            )}
          </div>

          <button type="submit" style={submitStyle}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #ddd",
  fontSize: 14,
  marginTop: 4,
  boxSizing: "border-box",
};

const labelStyle = {
  display: "block",
  marginBottom: 4,
  fontWeight: 500,
  color: "#333",
};

const submitStyle = {
  width: "100%",
  background: "#683FEA",
  color: "#fff",
  padding: "12px",
  borderRadius: 8,
  border: "none",
  fontSize: 16,
  cursor: "pointer",
  marginTop: 8,
};
